// AreaMultiSelect.js
import React from 'react';
import './AreaMultiSelect.css';

const AreaMultiSelect = ({ areas, selectedAreaIds, onChange }) => {
  const toggleArea = (id) => {
    if (selectedAreaIds.includes(id)) {
      onChange(selectedAreaIds.filter(aid => aid !== id));
    } else {
      onChange([...selectedAreaIds, id]);
    }
  };

  return (
    <div className="area-multiselect">
      <label className="area-label">Filter by Area:</label>
      <div className="area-tags">
        {areas.map(area => (
          <div
            key={area.id}
            className={`area-tag ${selectedAreaIds.includes(area.id) ? 'selected' : ''}`}
            onClick={() => toggleArea(area.id)}
          >
            {area.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AreaMultiSelect;
